import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        const user = res.data.user;
        const token = res.data.session_token;
        if (token) localStorage.setItem("trex_token", token);
        if (res.data.csrf_token) localStorage.setItem("trex_csrf", res.data.csrf_token);
        setUser(user);
        // clear hash
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Authentication failed");
      }
    })();
  }, []);

  return (
    <div className="admin-shell min-h-screen bg-bone flex items-center justify-center" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="font-serif text-xl text-aubergine">{error}</p>
          <button
            className="mt-6 inline-flex items-center justify-center rounded-md border border-aubergine/20 hover:bg-aubergine/5 px-4 py-2 font-mono text-xs"
            onClick={() => navigate("/admin/login", { replace: true })}
            data-testid="auth-callback-retry"
          >
            Back to login
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-aubergine/65">
          <Loader2 className="h-5 w-5 animate-spin text-champagne" />
          <span className="font-mono text-xs uppercase tracking-[0.15em]">Signing you in…</span>
        </div>
      )}
    </div>
  );
}
